import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

// Data
import subscriptionTableData from "layouts/subscription/data/subscriptionTableData";
import { useEffect, useMemo, useState } from "react";
import { getAllSubscriptions } from "services/apiService";

function Subscriptions() {
  const [people, setPeople] = useState([]);
  const [page, setPage] = useState(1);

  useEffect(() => {
    getAllData();
  }, []);

  const getAllData = async () => {
    try {
      const response = await getAllSubscriptions();
      if (response?.success) {
        setPeople(response?.data?.users);
      }
    } catch (err) {
      console.error("Fetch users failed:", err);
    }
  };

  const { columns, rows } = useMemo(() => {
    return subscriptionTableData({
      peopleList: people,
    });
  }, [people]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  User Subscriptions
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={{ defaultValue: 10, entries: [10, 15, 20, 35, 50] }}
                  showTotalEntries={true}
                  noEndBorder
                  canSearch={true}
                  page={page}
                  onPageChange={setPage}
                  searchFn={(user, query) => {
                    const lowerQuery = query?.toLowerCase();
                    return (
                      user?.expiry_date?.props?.children?.toLowerCase().includes(lowerQuery) ||
                      user?.plan?.props?.children?.toLowerCase().includes(lowerQuery) ||
                      user?.plan_price?.props?.children?.toLowerCase().includes(lowerQuery) ||
                      user?.status?.props?.children?.props?.badgeContent
                        .toLowerCase()
                        .includes(lowerQuery) ||
                      user?.purchased?.props?.children?.toLowerCase().includes(lowerQuery) ||
                      user?.user?.props?.name?.toLowerCase().includes(lowerQuery) ||
                      user?.user?.props?.contact?.toLowerCase().includes(lowerQuery)
                    );
                  }}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Subscriptions;
